import React from 'react';
import DashboardScreen from './DashboardScreen';

const Index = () => {
  return <DashboardScreen />;
};

export default Index;
